import { render, staticRenderFns } from "./SinglePOI.vue?vue&type=template&id=5ea72278"
import script from "./SinglePOI.vue?vue&type=script&lang=js"
export * from "./SinglePOI.vue?vue&type=script&lang=js"
import style0 from "./SinglePOI.vue?vue&type=style&index=0&id=5ea72278&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports